"use strict";
var thesaurusCtrl = require('./thesaurusCtrl');
var commentsCtrl = require('./commentsCtrl');
var lodEntriesCtrl = require('./lodEntriesCtrl');
var referencesCtrl = require('./referencesCtrl');
var hlp = require('common/helpers');
var validators = require('common/validators');
var META_FIELD_LOD_DATA = "lod_data";
var META_FIELD_COMMENTS = "comments";
var META_FIELD_REFERENCES = "references";
var ICONENTRIES = {
  "comment": {
    title: 'Kommentare',
    icon: 'fa-comment pointer'
  },
  "lodentry": {
    title: 'LOD-Einträge',
    icon: 'fa-external-link pointer'
  },
  "reference": {
    title: 'Quellen',
    icon: 'fa-info pointer'
  },
  "unconfirmed": {
    title: 'Unsicher',
    icon: 'fa-question'
  },
  "remarkable": {
    title: 'Bemerkenswert',
    icon: 'fa-star'
  },
  "primary": {
    title: 'Hauptbild, wird in Vorschau verwendet.',
    icon: 'fa-star'
  },
  "hidden": {
    title: 'Bild wird versteckt und ist nur im bearbeiten Modus sichtbar.',
    icon: 'fa-ban'
  },
  "detail": {
    title: 'Bild zeigt Detailaufnahme.',
    icon: 'fa-cube'
  },
  "total": {
    title: 'Bild Gesamte Aufnahme.',
    icon: 'fa-cubes'
  },
  "outdated": {
    title: 'Alte Aufnahme vom Bild.',
    icon: 'fa-clock-o'
  }
};
var fieldEntryCtrl = function($scope, $uibModal, $sce, $http, $q) {
  var init = function() {
    initIcons();
  };
  var initIcons = function() {
    $scope.icons = [];
    $scope.icons.push({
      title: ICONENTRIES.comment.title,
      icon: ICONENTRIES.comment.icon,
      show: function() {
        return $scope.entry.comments && $scope.entry.comments.length > 0;
      },
      click: function() {
        if ($scope.readonly) {
          setHelpText($scope.entry.comments, "comments");
        } else {
          $scope.showComments();
        }
      }
    });
    $scope.icons.push({
      title: ICONENTRIES.reference.title,
      icon: ICONENTRIES.reference.icon,
      show: function() {
        return $scope.entry.references && $scope.entry.references.length > 0;
      },
      click: function() {
        if ($scope.readonly) {
          setHelpText($scope.entry.references, "references");
        } else {
          $scope.showReferences();
        }
      }
    });
    $scope.icons.push({
      title: ICONENTRIES.lodentry.title,
      icon: ICONENTRIES.lodentry.icon,
      show: function() {
        return $scope.entry[META_FIELD_LOD_DATA] && $scope.entry[META_FIELD_LOD_DATA].length > 0;
      },
      click: function() {
        if ($scope.readonly) {
          setHelpText($scope.entry[META_FIELD_LOD_DATA], "lodentry");
        } else {
          $scope.showLodEntries();
        }
      }
    });
    $scope.icons.push({
      title: ICONENTRIES.unconfirmed.title,
      icon: ICONENTRIES.unconfirmed.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.unconfirmed == true;
      },
      click: null
    });
    $scope.icons.push({
      title: ICONENTRIES.remarkable.title,
      icon: ICONENTRIES.remarkable.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.remarkable == true;
      },
      click: null
    });
    $scope.icons.push({
      title: ICONENTRIES.primary.title,
      icon: ICONENTRIES.primary.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.primary ? true : false;
      },
      click: null
    });
    $scope.icons.push({
      title: ICONENTRIES.hidden.title,
      icon: ICONENTRIES.hidden.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.hidden ? true : false;
      },
      click: null
    });
    $scope.icons.push({
      title: ICONENTRIES.detail.title,
      icon: ICONENTRIES.detail.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.detail ? true : false;
      },
      click: null
    });
    $scope.icons.push({
      title: ICONENTRIES.total.title,
      icon: ICONENTRIES.total.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.total ? true : false;
      },
      click: null
    });
    $scope.icons.push({
      title: ICONENTRIES.outdated.title,
      icon: ICONENTRIES.outdated.icon,
      show: function() {
        return $scope.entry.flags && $scope.entry.flags.outdated ? true : false;
      },
      click: null
    });
  };
  var setHelpText = function(list, type) {
    $scope.helpText = [];
    if ($scope.helpTextType == type) {
      $scope.helpTextType = null;
      return;
    }
    for (var i = 0; i < list.length; i++) {
      if (type == 'lodentry') {
        $scope.helpText.push(list[i].source + ": " + list[i].id);
      } else {
        $scope.helpText.push(list[i].text);
      }
    }
    $scope.helpTextType = type;
  };
  $scope.typeaheadValue = function(term) {
    if (typeof(term) == 'undefined') {
      return $scope.entry.value;
    } else {
      if (typeof(term) == 'string') {
        $scope.entry.value = term;
        delete($scope.entry.thesaurus_id);
      } else {
        if (checkLodChanged($scope.entry, term) && hlp.isSet($scope.entry.lod_data) && $scope.entry.lod_data.length > 0) {
          showConfirmLodChangesModal(term);
        } else {
          $scope.entry.lod_data = term.lod_data;
        }
        $scope.entry.value = term.shortName;
        $scope.entry.thesaurus_id = term.id;
      }
    }
  };
  $scope.isValid = function() {
    return validators.validate($scope.schema, $scope.entry);
  };
  $scope.showThesaurus = function() {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/thesaurus.ng.html',
      backdrop: 'static',
      controller: thesaurusCtrl,
      size: 'lg',
      resolve: {thesaurusParams: function() {
          return {
            thesaurus_name: $scope.schema.thesaurus,
            current_id: $scope.entry.thesaurus_id,
            current_value: $scope.entry.value
          };
        }}
    });
    modal.result.then(function(term) {
      if (checkLodChanged($scope.entry, term) && hlp.isSet($scope.entry.lod_data) && $scope.entry.lod_data.length > 0) {
        showConfirmLodChangesModal(term);
      } else {
        $scope.entry.lod_data = term.lod_data;
      }
      $scope.entry.value = term.shortName;
      $scope.entry.thesaurus_id = term.id;
    });
  };
  var checkLodChanged = function(entry, term) {
    if (hlp.isSet(entry.lod_data) && hlp.isSet(term.lod_data)) {
      return false;
    }
    if ((!hlp.isSet(entry.lod_data) && hlp.isSet(term.lod_data)) || (hlp.isSet(entry.lod_data) && !hlp.isSet(term.lod_data)) || entry.lod_data.length != term.lod_data.length) {
      return true;
    }
    for (var i = 0; i < entry.lod_data.length; i++) {
      if (entry.lod_data[i].id != term.lod_data[i].id && entry.lod_data[i].source != term.lod_data[i].source) {
        return true;
      }
    }
    return false;
  };
  var showConfirmLodChangesModal = function(term) {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/confirmlodchanges.ng.html',
      backdrop: 'static'
    });
    modal.result.then(function(result) {
      if (result) {
        $scope.entry.lod_data = term.lod_data;
      }
    });
  };
  $scope.showPopover = function(entry, type) {
    var content = '<ul>';
    if (hlp.isSet(entry[type])) {
      for (var i = 0; i < entry[type].length; i++) {
        content += '<li>' + entry[type][i].text + '</li>';
      }
    }
    content += '</ul>';
    $sce.trustAsHtml(content);
  };
  $scope.showComments = function() {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/comments.ng.html',
      backdrop: 'static',
      controller: commentsCtrl,
      size: 'lg',
      resolve: {commentsParams: function() {
          if (!$scope.entry[META_FIELD_COMMENTS]) {
            $scope.entry[META_FIELD_COMMENTS] = [];
          }
          return {comments: $scope.entry[META_FIELD_COMMENTS].slice(0) || []};
        }}
    });
    modal.result.then(function(entries) {
      $scope.entry[META_FIELD_COMMENTS] = entries;
    });
  };
  $scope.showLodEntries = function() {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/lodentries.ng.html',
      backdrop: 'static',
      controller: lodEntriesCtrl,
      size: 'lg',
      resolve: {lodParams: function() {
          if (!$scope.entry[META_FIELD_LOD_DATA]) {
            $scope.entry[META_FIELD_LOD_DATA] = [];
          }
          return {entries: $scope.entry[META_FIELD_LOD_DATA].slice(0) || []};
        }}
    });
    modal.result.then(function(entries) {
      $scope.entry[META_FIELD_LOD_DATA] = entries;
    });
  };
  $scope.showReferences = function() {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/references.ng.html',
      backdrop: 'static',
      controller: referencesCtrl,
      size: 'lg',
      resolve: {referencesParams: function() {
          if (!$scope.entry[META_FIELD_REFERENCES]) {
            $scope.entry[META_FIELD_REFERENCES] = [];
          }
          return {references: $scope.entry[META_FIELD_REFERENCES].slice(0) || []};
        }}
    });
    modal.result.then(function(entries) {
      $scope.entry[META_FIELD_REFERENCES] = entries;
    });
  };
  $scope.toggleFlag = function(entry, flag, value) {
    if (value == null && entry.flags != null && entry.flags[flag] != null) {
      value = !entry.flags[flag];
    } else if (value == null && (entry.flags == null || entry.flags[flag] == null)) {
      value = true;
    }
    if (entry.flags == null) {
      entry.flags = {};
    }
    entry.flags[flag] = value;
  };
  var hasThesaurus = function() {
    if (hlp.isSet($scope.schema.thesaurus) && $scope.schema.thesaurus != false) {
      return true;
    }
    return false;
  };
  var getThesauri = function(query) {
    return $http.get('/api/thesaurus/' + $scope.schema.thesaurus + '/term.json?no_categories=true&query=' + query).then(function(response) {
      return response.data.terms;
    });
  };
  $scope.getThesauri = getThesauri;
  init();
};
fieldEntryCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http', '$q'];
module.exports = fieldEntryCtrl;
